import sanityClient from '@sanity/client'

export default sanityClient({
    projectId:"vjw7yzbl",
    dataset: "production"
})